import { render } from "./GetConfiguration.vue?vue&type=template&id=a49f7a10&scoped=true"
import script from "./GetConfiguration.vue?vue&type=script&lang=js"
export * from "./GetConfiguration.vue?vue&type=script&lang=js"

import "./GetConfiguration.vue?vue&type=style&index=0&id=a49f7a10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a49f7a10"]])

export default __exports__